export const manifest = {
  screens: {
    scr_8tgrem: { name: "Home", route: "/" },
  },
}
